var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"text"},[_vm._v("シェーマ画像選択")]),_c('img',{attrs:{"src":require("@/assets/images/select.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }